module.exports = __webpack_public_path__ + "static/media/Seriesvn.f0f25374.pdf";